/**
 * ONE WHATSAPP LINK FOR EVERY BROWSER THE SHOP IS OPENED IN — AND IT IS THE PLAIN wa.me LINK (2026-10-14).
 *
 * THE RECORD OF WHAT WAS TRIED. Inside Facebook's and Instagram's web view the shop's WhatsApp button did not open
 * WhatsApp, and this file rewrote the href three times trying to make it:
 *   · `whatsapp://send?phone=…&text=…` — the app's own scheme, from 2026-10-03. A month of DK: every recorded
 *     in-app tap `opened:false`.
 *   · `x-safari-https://wa.me/…` on an iPhone and `intent://send?…#Intent;scheme=whatsapp;package=com.whatsapp;…;end`
 *     on Android — the ad doorway's door, from 2026-10-12. The logs say it failed too: EVERY in-app tap on 10-12
 *     and 10-13 from a phone that was not the owner's recorded `shop_contact_order_result opened:false`
 *     (visitor keys 1106b9a2 ×3, 2f67ab4f ×2, b93a5f62).
 *
 * WHAT ACTUALLY WORKS, and the owner's own observation that found it: the Google reviews link on the same product
 * page is a plain `https://` link, tapped in the same frame, and it DOES open the native Google app from inside
 * Instagram's web view. That is an iOS universal link / Android app link being honoured, and WhatsApp owns `wa.me`
 * as one. They are honoured only for a USER-INITIATED navigation in the SAME frame — never for a new tab, never
 * for a scripted `window.open` or `location` change. Which also explains the one earlier wa.me attempt
 * (2026-10-03): it carried `target="_blank"`, so the web view handled it as a new tab and showed WhatsApp Web's
 * login wall instead of handing it to the app.
 *
 * So nothing is rewritten any more, in any browser: the control is a real `<a href="https://wa.me/<digits>?text=…">`
 * with no target, no `window.open`, no scripted navigation and no `preventDefault` — the tap itself is the
 * navigation. What stays is the watch: inside an in-app browser, a page still in front 1.5 s after the tap means
 * nothing opened, and the shopper is offered the doors that do work (Components/WhatsAppLink, ContactOrderFallback).
 * `whatsappAppHref` survives for exactly one caller: that sheet's "Open WhatsApp" button, which the shopper asks
 * for by name after the first tap opened nothing.
 */
import { isInAppBrowser } from './stableViewport';
import { osOf } from './openInBrowser';

const WA_ME = /^https:\/\/wa\.me\/(\d{6,})(?:\?(.*))?$/;

/** The digits and the first-line text a wa.me link carries, or null for anything that is not a wa.me link. */
export function parseWaMe(url) {
  const m = WA_ME.exec(String(url || '').trim());
  if (!m) return null;
  const query = new URLSearchParams(m[2] || '');
  const text = query.get('text');
  return { phone: m[1], text: text || '' };
}

/**
 * `whatsapp://send?phone=…&text=…` for a wa.me link; anything else is returned as it came.
 * THE SECOND ATTEMPT ONLY — the sheet's "Open WhatsApp", after the plain link opened nothing. Never the href a
 * control carries: those browsers swallow this scheme (a month of `opened:false`).
 */
export function whatsappAppHref(url) {
  const parsed = parseWaMe(url);
  if (!parsed) return url;
  return `whatsapp://send?phone=${parsed.phone}${parsed.text ? `&text=${encodeURIComponent(parsed.text)}` : ''}`;
}

/** Whether this page runs inside Facebook's, Instagram's or Messenger's browser. */
export function inAppBrowserNow(nav = typeof navigator !== 'undefined' ? navigator : undefined) {
  return isInAppBrowser(nav && nav.userAgent);
}

/** The phone this page runs on: 'ios' | 'android' | 'other'. */
export function osNow(nav = typeof navigator !== 'undefined' ? navigator : undefined) {
  return osOf(nav && nav.userAgent);
}

/**
 * The href a WhatsApp control carries HERE — the wa.me link, untouched, in every browser.
 *
 * It takes no browser and no OS: since 2026-10-14 the answer does not depend on them (see the head of this file),
 * and this is the one place that says so, for every surface that renders a WhatsApp control.
 */
export function whatsappHrefFor(url) {
  return url;
}
